import React, { ElementType, memo, MouseEventHandler, useMemo } from "react";
import { HStack, Spacer, Text } from "@chakra-ui/react";
import colors from "app/colors";
import Link from "modules/layouts/_shared/link";
import { IconProps } from "@chakra-ui/icon";
import useStickyFilter from "modules/hooks/use-sticky-filter";
import { useRouter } from "next/router";
import LeftNavUnseenCount from "./left-nav-unseen-count";

const ICON_BOX_SIZE = 4;

interface IProps {
  title: string;
  icon: ElementType<IconProps>;
  path: string;
  color: string;
  onClick?: MouseEventHandler | undefined;
  unseenCountIcon?: ElementType<IconProps>;
  unseenCountLabel?: string;
  unseenCount?: number;
}

const LeftNavLink = ({
  title,
  icon: Icon,
  path,
  color,
  onClick,
  unseenCountIcon: UnseenCountIcon,
  unseenCountLabel = "",
  unseenCount,
}: IProps) => {
  const { asPath } = useRouter();

  const { url: href } = useStickyFilter({
    path,
  });

  const selected = useMemo(() => asPath.startsWith(path), [asPath, path]);

  const bgColor = selected ? `${color}4D` : "transparent";

  const fontColor = selected ? colors.white : colors.gray30;

  const fillColor = selected ? colors.white : color;

  const fontWeight = selected ? 800 : 500;

  return (
    <Link href={href} w="full" onClick={onClick} px={1}>
      <HStack
        w="full"
        bg={bgColor}
        py={1}
        pl={3}
        pr={2}
        borderRadius={4}
        _hover={{ bg: `${color}33` }}
      >
        <Icon fill={fillColor} boxSize={ICON_BOX_SIZE} />
        <Text fontSize={14} color={fontColor} fontWeight={fontWeight}>
          {title}
        </Text>
        <Spacer />
        <LeftNavUnseenCount
          unseenCount={unseenCount}
          color={color}
          unseenCountIcon={UnseenCountIcon}
          unseenCountLabel={unseenCountLabel}
        />
      </HStack>
    </Link>
  );
};

export default memo(LeftNavLink);
